var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"main-content-section"},[_c('tl-tabs',{attrs:{"tabs":_vm.tabs}},[_c('tl-tab',[_c('monthly-payslips',{on:{"stepNum":function($event){return _vm.$emit('stepNum',4)}}})],1),_c('tl-tab',[_c('fnf-payslips',{on:{"stepNum":function($event){return _vm.$emit('stepNum',4)}}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }